export default __webpack_public_path__ + "static/media/otpview@2x.6b4f637f.png";